// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 32 32%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%28255,255,255, 1%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 8h24M4 16h24M4 24h24%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav {
    background: #1E90FF; 	
    box-shadow: 0px 0px 5px black; 	
}

div .navbar-light .navbar-toggler {
    border-color: white;
}

div .navbar-light .navbar-toggler .navbar-toggler-icon{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

nav a.navbar-brand {
    padding: 10px;
    margin-left: 20%;
}

@media only screen and (min-width: 768px) {
    nav a.navbar-brand {
        margin-right: 2%;
        color: white;
        margin-left: 0%;

    }
}

.navbar-light .navbar-nav a.nav-link {
    color: #f8f9fa;
    font-size: 18px;
    transition: all 0.2ms;
}

 div li .dropright .dropdown .nav-item {
    font-size: 16px;
}


@media only screen and (min-width: 768px) {
    ul li.dropdown:hover
    { 
        background-color: #1E90FF;
        color: #1E90FF;
    }

    ul li.dropdown:active
    { 
        background-color: #1E90FF;
        color: #1E90FF;
    }
    
    ul li.dropdown:hover ul.dropdown-menu
    { 
        display: block; 
    }

    div ul li {
        border-radius: 2px;
        color: white;
        margin-left: 0%;
    }
    div .menus {
        background: #1E90FF; 	
        box-shadow: 0px 0px 5px black; 	
    }
}

div .menus button {
    color: white;
    border-radius: 0px;
    transition: all 0.2s;
}

div ul li.dropright .dropdown .show .nav-item {
    background: #1E90FF;
    color: white;
}

@media only screen and (min-width: 768px) {
    div .menus button {
        color: white;
        border-radius: 0px;
        border: 0;
        transition: all 0.2s;
    }

    div .menus button:hover, .material-icons:hover {
        color: black;
        border-radius: 0px;
        border: none;
        transition: all 0.2s;
        background-color: #1E90FF;
    }

    div .menus button:active, .material-icons:active {
        color: black;
        border-radius: 0px;
        border: none;
        transition: all 0.2s;
        background-color: #1E90FF;
    }

    .dropdown-item:focus, .dropdown-item:hover {
        background: #1E90FF;
        color: white;
    }

}


div ul li a button.dropdown-item:focus, button.dropdown-item:hover {
    background: #1E90FF;
    color: white;
}

@media only screen and (min-width: 768px) {
    button.dropdown-item:focus, button.dropdown-item:hover {
        background-color: #1E90FF;
        color: white;
    }
}


div ul li a.dropdown-toggle {
    color: white;
}

div ul li .menus {
    border: 15px;
}

@media only screen and (min-width: 768px) {
    div ul li .menus {
        border: 0;
        border-radius: 5px;
        margin-top: 0%;
    }

    div .nav-link {
        color: white;
        font-size: 16px;
        margin-left: 4%;
    } 

    div #menus {
        color: white;
        font-size: 15px;
        padding: 0%;
        margin: 0%;
    } 

    #geral {
        margin-left: 0%;
        padding: 0%;
        width: 100%;
    }
    
    #li2 {

        margin-left: 2%;
    }
}

div ul {
    padding: 0 0 3% 0;
    border: none;
}

@media only screen and (min-width: 768px) {
    div ul {
        padding: 0 10% 0 0%;
        border: none;
    }

    .material-icons {
        vertical-align: middle;
        position: relative;
    }
}

.material-icons {
    vertical-align: middle;
    position: relative;
}


/* ---------------------------------------------------
   SAIR
----------------------------------------------------- */

#BotaoSair {
    text-align: center;
    text-decoration: white; 
    list-style:none;
    background: #1E90FF;
    color: white;
    border-radius: 5px;
    top: 100%;

   

}

@media only screen and (min-width: 768px) {
    #BotaoSair {
        text-align: center;
        text-decoration: none; 
        list-style:none;
        background: #1E90FF;
        color: white;
        border-radius: 5px;
        top: 100%;
        width: 8%;
       
    }

    a .img {
        width: 16vh;
        height: 10vh;
    }

    
}

#BotaoSair .btn {
    color: white;
}

#BotaoSair .btn:hover {
    color: black;
    background-color: #1E90FF;
}

#BotaoSair .material-icons {
    vertical-align: middle;
    position: relative;
    
}

#BotaoSair1{
    float: right;
 }

 /* ---------------------------------------------------
   LOGO
----------------------------------------------------- */

.img {
    /* width: 22vh;
    height: 14vh; */

    width: 14vh;
    margin: 10px 0;
}

`, "",{"version":3,"sources":["webpack://./src/components/menuSuperior/MenuSuperior.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IAGX,6BAA6B;AACzC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yDAAuQ;AAC3Q;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;QAChB,YAAY;QACZ,eAAe;;IAEnB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;AACzB;;CAEC;IACG,eAAe;AACnB;;;AAGA;IACI;;QAEI,yBAAyB;QACzB,cAAc;IAClB;;IAEA;;QAEI,yBAAyB;QACzB,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,eAAe;IACnB;IAIA;QACI,mBAAmB;QAGX,6BAA6B;IACzC;AARJ;;AAWA;IACI,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI;QACI,YAAY;QACZ,kBAAkB;QAClB,SAAS;QACT,oBAAoB;IACxB;;IAEA;QACI,YAAY;QACZ,kBAAkB;QAClB,YAAY;QACZ,oBAAoB;QACpB,yBAAyB;IAC7B;;IAEA;QACI,YAAY;QACZ,kBAAkB;QAClB,YAAY;QACZ,oBAAoB;QACpB,yBAAyB;IAC7B;;IAEA;QACI,mBAAmB;QACnB,YAAY;IAChB;;AAEJ;;;AAGA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI;QACI,yBAAyB;QACzB,YAAY;IAChB;AACJ;;;AAGA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,SAAS;QACT,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,WAAW;QACX,UAAU;IACd;;IAEA;QACI,eAAe;QACf,WAAW;QACX,WAAW;IACf;;IAEA;;QAEI,eAAe;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI;QACI,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;;AAGA;;uDAEuD;;AAEvD;IACI,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,SAAS;;;;AAIb;;AAEA;IACI;QACI,kBAAkB;QAClB,qBAAqB;QACrB,eAAe;QACf,mBAAmB;QACnB,YAAY;QACZ,kBAAkB;QAClB,SAAS;QACT,SAAS;;IAEb;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;;AAGJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;;AAEtB;;AAEA;IACI,YAAY;CACf;;CAEA;;uDAEsD;;AAEvD;IACI;mBACe;;IAEf,WAAW;IACX,cAAc;AAClB","sourcesContent":["nav {\n    background: #1E90FF; \n    -webkit-box-shadow: 0px 0px 5px black; \t\n    -moz-box-shadow: 0px 0px 5px black; \t\n            box-shadow: 0px 0px 5px black; \t\n}\n\ndiv .navbar-light .navbar-toggler {\n    border-color: white;\n}\n\ndiv .navbar-light .navbar-toggler .navbar-toggler-icon{\n    background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255,255,255, 1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E\");\n}\n\nnav a.navbar-brand {\n    padding: 10px;\n    margin-left: 20%;\n}\n\n@media only screen and (min-width: 768px) {\n    nav a.navbar-brand {\n        margin-right: 2%;\n        color: white;\n        margin-left: 0%;\n\n    }\n}\n\n.navbar-light .navbar-nav a.nav-link {\n    color: #f8f9fa;\n    font-size: 18px;\n    transition: all 0.2ms;\n}\n\n div li .dropright .dropdown .nav-item {\n    font-size: 16px;\n}\n\n\n@media only screen and (min-width: 768px) {\n    ul li.dropdown:hover\n    { \n        background-color: #1E90FF;\n        color: #1E90FF;\n    }\n\n    ul li.dropdown:active\n    { \n        background-color: #1E90FF;\n        color: #1E90FF;\n    }\n    \n    ul li.dropdown:hover ul.dropdown-menu\n    { \n        display: block; \n    }\n\n    div ul li {\n        border-radius: 2px;\n        color: white;\n        margin-left: 0%;\n    }\n}\n\n@media only screen and (min-width: 768px) {\n    div .menus {\n        background: #1E90FF;\n        -webkit-box-shadow: 0px 0px 5px black; \t\n        -moz-box-shadow: 0px 0px 5px black; \t\n                box-shadow: 0px 0px 5px black; \t\n    }\n}\n\ndiv .menus button {\n    color: white;\n    border-radius: 0px;\n    transition: all 0.2s;\n}\n\ndiv ul li.dropright .dropdown .show .nav-item {\n    background: #1E90FF;\n    color: white;\n}\n\n@media only screen and (min-width: 768px) {\n    div .menus button {\n        color: white;\n        border-radius: 0px;\n        border: 0;\n        transition: all 0.2s;\n    }\n\n    div .menus button:hover, .material-icons:hover {\n        color: black;\n        border-radius: 0px;\n        border: none;\n        transition: all 0.2s;\n        background-color: #1E90FF;\n    }\n\n    div .menus button:active, .material-icons:active {\n        color: black;\n        border-radius: 0px;\n        border: none;\n        transition: all 0.2s;\n        background-color: #1E90FF;\n    }\n\n    .dropdown-item:focus, .dropdown-item:hover {\n        background: #1E90FF;\n        color: white;\n    }\n\n}\n\n\ndiv ul li a button.dropdown-item:focus, button.dropdown-item:hover {\n    background: #1E90FF;\n    color: white;\n}\n\n@media only screen and (min-width: 768px) {\n    button.dropdown-item:focus, button.dropdown-item:hover {\n        background-color: #1E90FF;\n        color: white;\n    }\n}\n\n\ndiv ul li a.dropdown-toggle {\n    color: white;\n}\n\ndiv ul li .menus {\n    border: 15px;\n}\n\n@media only screen and (min-width: 768px) {\n    div ul li .menus {\n        border: 0;\n        border-radius: 5px;\n        margin-top: 0%;\n    }\n\n    div .nav-link {\n        color: white;\n        font-size: 16px;\n        margin-left: 4%;\n    } \n\n    div #menus {\n        color: white;\n        font-size: 15px;\n        padding: 0%;\n        margin: 0%;\n    } \n\n    #geral {\n        margin-left: 0%;\n        padding: 0%;\n        width: 100%;\n    }\n    \n    #li2 {\n\n        margin-left: 2%;\n    }\n}\n\ndiv ul {\n    padding: 0 0 3% 0;\n    border: none;\n}\n\n@media only screen and (min-width: 768px) {\n    div ul {\n        padding: 0 10% 0 0%;\n        border: none;\n    }\n\n    .material-icons {\n        vertical-align: middle;\n        position: relative;\n    }\n}\n\n.material-icons {\n    vertical-align: middle;\n    position: relative;\n}\n\n\n/* ---------------------------------------------------\n   SAIR\n----------------------------------------------------- */\n\n#BotaoSair {\n    text-align: center;\n    text-decoration: white; \n    list-style:none;\n    background: #1E90FF;\n    color: white;\n    border-radius: 5px;\n    top: 100%;\n\n   \n\n}\n\n@media only screen and (min-width: 768px) {\n    #BotaoSair {\n        text-align: center;\n        text-decoration: none; \n        list-style:none;\n        background: #1E90FF;\n        color: white;\n        border-radius: 5px;\n        top: 100%;\n        width: 8%;\n       \n    }\n\n    a .img {\n        width: 16vh;\n        height: 10vh;\n    }\n\n    \n}\n\n#BotaoSair .btn {\n    color: white;\n}\n\n#BotaoSair .btn:hover {\n    color: black;\n    background-color: #1E90FF;\n}\n\n#BotaoSair .material-icons {\n    vertical-align: middle;\n    position: relative;\n    \n}\n\n#BotaoSair1{\n    float: right;\n }\n\n /* ---------------------------------------------------\n   LOGO\n----------------------------------------------------- */\n\n.img {\n    /* width: 22vh;\n    height: 14vh; */\n\n    width: 14vh;\n    margin: 10px 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
